module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigate.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-back"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d165f35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/ButtonBack.vue
// module id = 504
// module chunks = 234